import React, { useRef, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import InputField from "../InputField";
import { Colors } from "../../../config";
import Before6 from "./Before6";
import After6 from "./After6";
import SixToTwelve from "./6to12";
import TwelveToSix from "./12to6";
import Button from "../../../components/Button";
const clock = require("../../../assets/images/clock.png");

const TravelTimeSelect = ({
  onTimeRangeSelect,
  departureTime,
  returnTime,
  helperText,
  returnJourney,
  required,
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const [selectedDepartureRange, setSelectDepartureRange] = useState("");
  const [selectedReturnRange, setSelectReturnRange] = useState("");
  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowOptions(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const handleShow = (e) => {
    e.preventDefault();
    setShowOptions(true);
  };

  useEffect(() => {
    setSelectDepartureRange(departureTime);
    setSelectReturnRange(returnTime);
  }, [departureTime, returnTime]);

  const handleDepartureTimeRangeSelect = (time) => {
    setSelectDepartureRange(time);
    onTimeRangeSelect(time, "departure");
  };
  const handleReturnTimeRangeSelect = (time) => {
    setSelectReturnRange(time);
    onTimeRangeSelect(time, "return");
  };

  return (
    <TravelTimeSelectWrapper ref={wrapperRef}>
      <InputWrapper>
        <InputField
          label={returnJourney ? "Departure & Return Time" : "Departure Time"}
          value={
            !departureTime && !returnTime
              ? "Select Preferred Time"
              : `${departureTime} ${
                  departureTime && returnJourney ? "," : ""
                } ${returnJourney ? returnTime : ""}`
          }
          placeholder={"Departure & Return Time"}
          isRounded
          onFocus={(e) => handleShow(e)}
          helperText={helperText}
          required={required}
        />
        <RightImg
          src={clock}
          onClick={(e) => handleShow(e)}
          helperText={helperText}
        />
      </InputWrapper>
      {showOptions && (
        <Options>
          <ListOptions>
            <ListHeader>Departure Preferred Time</ListHeader>
            <SelectList>
              <TimeRange
                onClick={() =>
                  handleDepartureTimeRangeSelect("12:00AM to 6:00AM")
                }
              >
                <Before6
                  selected={selectedDepartureRange === "12:00AM to 6:00AM"}
                />
              </TimeRange>
              <TimeRange
                onClick={() =>
                  handleDepartureTimeRangeSelect("6:00AM to 12:00PM")
                }
              >
                <SixToTwelve
                  selected={selectedDepartureRange === "6:00AM to 12:00PM"}
                />
              </TimeRange>
              <TimeRange
                onClick={() =>
                  handleDepartureTimeRangeSelect("12:00PM to 6:00PM")
                }
              >
                <TwelveToSix
                  selected={selectedDepartureRange === "12:00PM to 6:00PM"}
                />
              </TimeRange>
              <TimeRange
                onClick={() =>
                  handleDepartureTimeRangeSelect("6:00PM to 12:00AM")
                }
              >
                <After6
                  selected={selectedDepartureRange === "6:00PM to 12:00AM"}
                />
              </TimeRange>
            </SelectList>
          </ListOptions>
          {returnJourney && (
            <ListOptions>
              <ListHeader>Return Arrival Preferred Time</ListHeader>
              <SelectList>
                <TimeRange
                  onClick={() =>
                    handleReturnTimeRangeSelect("12:00AM to 6:00AM")
                  }
                >
                  <Before6
                    selected={selectedReturnRange === "12:00AM to 6:00AM"}
                  />
                </TimeRange>
                <TimeRange
                  onClick={() =>
                    handleReturnTimeRangeSelect("6:00AM to 12:00PM")
                  }
                >
                  <SixToTwelve
                    selected={selectedReturnRange === "6:00AM to 12:00PM"}
                  />
                </TimeRange>
                <TimeRange
                  onClick={() =>
                    handleReturnTimeRangeSelect("12:00PM to 6:00PM")
                  }
                >
                  <TwelveToSix
                    selected={selectedReturnRange === "12:00PM to 6:00PM"}
                  />
                </TimeRange>
                <TimeRange
                  onClick={() =>
                    handleReturnTimeRangeSelect("6:00PM to 12:00AM")
                  }
                >
                  <After6
                    selected={selectedReturnRange === "6:00PM to 12:00AM"}
                  />
                </TimeRange>
              </SelectList>
            </ListOptions>
          )}
          <Button
            bgColor={"red"}
            label={"Done"}
            topBottomPadding="0.75rem"
            fontSize="0.8rem"
            onClick={() => setShowOptions(false)}
          />
        </Options>
      )}
    </TravelTimeSelectWrapper>
  );
};

const RightImg = styled.img`
  width: 1.5rem;
  position: absolute;
  bottom: 0.9rem;
  right: 1rem;
  background: ${Colors.white};
  ${(props) =>
    props.helperText &&
    css`
      bottom: 2rem;
    `}
`;
const InputWrapper = styled.div``;
const TimeRange = styled.div``;
const ListOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 1rem 0;
`;
const ListHeader = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
`;
const SelectList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  justify-content: space-between;
`;
const ClassCard = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid
    ${(props) => (props.selected ? Colors.pomegranate : Colors.alto)};
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  background: ${(props) =>
    props.selected ? Colors.pomegranateOpacity10 : "transparent"};
`;
const ClassWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
`;
const Options = styled.div`
  position: absolute;
  width: 90%;
  padding: 1rem;
  border-radius: 1rem;
  background: ${Colors.white};
  top: 4.5rem;
  border: 1px solid ${Colors.sharkApproxOpacity40};
  display: flex;
  flex-direction: column;
  z-index: 9999;
  @media only screen and (max-width: 768px) {
    width: 90%;
  }
`;
const TravelTimeSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export default TravelTimeSelect;
